import Cookies from 'js-cookie';

document.addEventListener('DOMContentLoaded', () => init_switcher(), false);

async function init_switcher() {
	// Subdomain redirect logic
	let parent = false;
	let list = false;

	let prompt = document.getElementById('location-prompt');
	let prompt_select = document.getElementById('location-prompt-select');

	let locationContainer = document.getElementById('location-container');

	if (prompt) {
		//fetch locally stored detected locale
		let set_locale = Cookies.get('locale');
		let detected_locale = Cookies.get('locale_detected');

		if (!set_locale) {
			//if we've stored a detected locale, use it
			if (detected_locale) {
				//open the prompt using the stored detected locale
				open_prompt(detected_locale);
			} else {
				//build a request
				var xmlHttp = new XMLHttpRequest();

				//on success, trigger this function
				xmlHttp.onreadystatechange = function () {
					if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
						//parse the response data
						let response_json = JSON.parse(xmlHttp.responseText);

						//attempt to get the country code
						let country_code = response_json.countryCode;

						//open the prompt
						open_prompt(country_code ? country_code : false);
					} else {
						//open the prompt without any selection
						open_prompt();
					}
				};

				// //set the request url to the reverse geolocation service
				xmlHttp.open(
					'GET',
					document.body.dataset.json + 'get_country',
					true
				); // true for asynchronous

				//make request
				xmlHttp.send();
			}
		}
	}

	function open_prompt(country_code = false) {
		setTimeout(function () {
			//if we've been passed a country code
			if (country_code) {
				//set the cookie
				Cookies.set('locale_detected', country_code, {
					expires: 30,
					path: '/',
				});
			}

			//if we can target the select
			if (prompt_select) {
				//if we've been passed a country code
				if (
					country_code &&
					document.querySelector(
						'#location-prompt-select option[value="' +
							country_code +
							'"]'
					)
				) {
					//set the prompt to this locale
					prompt_select.value = country_code;
				} else {
					prompt_select.value = 'GB';
				}

				//update the detected locale cookie
				Cookies.set('locale_detected', country_code, {
					expires: 30,
					path: '/',
				});

				//unhide it
				prompt.classList.remove('hidden');

				//move us to the top of the page
				window.scrollTo(0, 0);

				//grab its height
				let prompt_height = prompt.offsetHeight;

				//use the height to make it go off screen
				prompt.style.marginTop = '-' + prompt_height + 'px';

				//wait a few ms for this to complete
				setTimeout(function () {
					//reveal the prompt
					prompt.classList.add('active');
				}, 100);
			}
		}, 250);
	}

	document.addEventListener('click', function (event) {
		// If the clicked element isn't a data-locale element
		if (!event.target.matches('[data-locale]')) return;

		event.preventDefault();

		switch_location(event.target.getAttribute('data-locale'));
	});

	if (prompt) {
		document.addEventListener('click', function (event) {
			// If the clicked element isn't a data-locale element
			if (!event.target.matches('#location-prompt-confirm')) return;

			event.preventDefault();

			switch_location(prompt_select.value);
		});
	}

	function switch_location(locale) {
		//if the locale provided is a URL
		if (locale.includes('http')) {
			//set the default locale to GB
			Cookies.set('locale', 'GB', { expires: 30, path: '/' });

			//redirect to the provided URL
			window.location.href = locale;
		} else {
			if (locale == 'na') {
				Cookies.set('locale', 'GB', { expires: 30, path: '/' });

				if (prompt) {
					//remove the active status
					prompt.classList.remove('active');
				}
			} else {
				if (locale == 'GB') {
					Cookies.set('locale', 'GB', { expires: 30, path: '/' });
					const url = new URL(window.location.href);
					url.searchParams.set('locale', 'default');
					window.history.replaceState(null, null, url); // or pushState
				} else {
					Cookies.set('locale', locale, { expires: 30, path: '/' });
				}

				let locales = document.querySelectorAll('[data-locale]');

				if (locales) {
					let temp = [];

					for (let i = 0; i < locales.length; i++) {
						temp.push(
							locales[i].getAttribute('data-locale').toLowerCase()
						);
					}

					locales = temp;
				}

				//get details about where we're going
				let target_host =
					window.location.hostname +
					(locale !== 'GB' ? '/' + locale.toLowerCase() : '');
				let target_path = window.location.pathname;

				if (locales) {
					for (let i = 0; i < locales.length; i++) {
						if (target_path.includes(locales[i])) {
							target_path = target_path.replace(
								locales[i] + '/',
								''
							);
						}
					}
				}

				let target_url = 'https://' + target_host + target_path;

				//if we have everything we need to redirect
				if (locale && target_url) {
					//make a fetch request to the target page
					fetch(target_url)
						.then((response) => {
							//if we have a response and it's valid (aka the page exists on the translated site)
							if (response && response.status == 200) {
								//redirect us there
								window.location.href = target_url;
							} else {
								//otherwise, the page doesn't exist

								//redirect us to the translated homepage
								window.location.href = 'https://' + target_host;
							}
						})
						.catch((err) => {
							//if something goes wrong

							//redirect to the translated homepage
							window.location.href = 'https://' + target_host;
						});
				} else {
					//do a simple reload
					location.reload();
				}
			}
		}
	}

	function open_switcher() {
		parent.classList.add('active');
		locationContainer.classList.add('switcher-active');
		list.getElementsByTagName('a')[0].focus();

		let anim_height = list.offsetHeight + 54 + 'px';
		list.style.height = '0px';

		setTimeout(function () {
			list.style.height = anim_height;
		}, 5);
	}

	function close_switcher() {
		parent.classList.remove('active');
		locationContainer.classList.remove('switcher-active');
		list.style.height = '';
	}

	let debounce = require('debounce');
	window.addEventListener(
		'resize',
		debounce(function (e) {
			if (parent && parent.classList.contains('active')) {
				close_switcher();
			}
		}, 200)
	);
}
